/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackAddedToPlaylistNotificationAction } from './TrackAddedToPlaylistNotificationAction';
import {
    TrackAddedToPlaylistNotificationActionFromJSON,
    TrackAddedToPlaylistNotificationActionFromJSONTyped,
    TrackAddedToPlaylistNotificationActionToJSON,
} from './TrackAddedToPlaylistNotificationAction';

/**
 * 
 * @export
 * @interface TrackAddedToPlaylistNotification
 */
export interface TrackAddedToPlaylistNotification {
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPlaylistNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPlaylistNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrackAddedToPlaylistNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrackAddedToPlaylistNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<TrackAddedToPlaylistNotificationAction>}
     * @memberof TrackAddedToPlaylistNotification
     */
    actions: Array<TrackAddedToPlaylistNotificationAction>;
}

/**
 * Check if a given object implements the TrackAddedToPlaylistNotification interface.
 */
export function instanceOfTrackAddedToPlaylistNotification(value: object): value is TrackAddedToPlaylistNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function TrackAddedToPlaylistNotificationFromJSON(json: any): TrackAddedToPlaylistNotification {
    return TrackAddedToPlaylistNotificationFromJSONTyped(json, false);
}

export function TrackAddedToPlaylistNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackAddedToPlaylistNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(TrackAddedToPlaylistNotificationActionFromJSON)),
    };
}

export function TrackAddedToPlaylistNotificationToJSON(value?: TrackAddedToPlaylistNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(TrackAddedToPlaylistNotificationActionToJSON)),
    };
}

